import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import ShiftReader from "@/pages/ShiftReader";
import ShiftResult from "@/pages/ShiftResult";
import Library from "@/pages/Library";
import Journal from "@/pages/Journal";
import Stories from "@/pages/Stories";
import Community from "@/pages/Community";
import Membership from "@/pages/Membership";
import Checkout from "@/pages/Checkout";
import Auth from "@/pages/Auth";
import Access from "@/pages/Access";
import FrequencyReset from "@/pages/programs/FrequencyReset";
import TimelineWorkbook from "@/pages/programs/TimelineWorkbook";
import ThirtyDayShift from "@/pages/programs/ThirtyDayShift";
import ReprogramReality from "@/pages/programs/ReprogramReality";
import ShiftPlus from "@/pages/programs/ShiftPlus";
import Founder from "@/pages/Founder";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <div className="App min-h-screen flex flex-col">
            <Header />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shift-reader" element={<ShiftReader />} />
                <Route path="/shift-reader/result/:id" element={<ShiftResult />} />
                <Route path="/library" element={<Library />} />
                <Route path="/journal" element={<Journal />} />
                <Route path="/stories" element={<Stories />} />
                <Route path="/community" element={<Community />} />
                <Route path="/membership" element={<Membership />} />
                <Route path="/checkout/:reference" element={<Checkout />} />
                <Route path="/auth" element={<Auth />} />
                <Route path="/access" element={<Access />} />
                <Route path="/programs/frequency-reset" element={<FrequencyReset />} />
                <Route path="/programs/timeline-workbook" element={<TimelineWorkbook />} />
                <Route path="/programs/thirty-day-shift" element={<ThirtyDayShift />} />
                <Route path="/programs/reprogram-reality" element={<ReprogramReality />} />
                <Route path="/programs/shift-plus" element={<ShiftPlus />} />
                <Route path="/founder" element={<Founder />} />
                <Route path="/about" element={<Navigate to="/founder" replace />} />
                <Route path="/pricing" element={<Navigate to="/membership" replace />} />
              </Routes>
            </main>
            <Footer />
          </div>
          <Toaster
            position="top-center"
            toastOptions={{
              style: {
                fontFamily: "JetBrains Mono, monospace",
                fontSize: "12px",
                letterSpacing: "0.05em",
              },
            }}
          />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
